module.exports = __webpack_public_path__ + "helveticaneue_medium.683bb6eaa0be548cea1e.woff";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/assets/fonts/helveticaneue_medium.woff
// module id = ../../../../../src/assets/fonts/helveticaneue_medium.woff
// module chunks = styles